import React, { useContext } from 'react';
import { Link, navigate } from 'gatsby';
import styled from '@emotion/styled';
import { FirebaseContext } from '@components/Firebase';
import { Container } from '@styles';
import * as ROUTES from '@utils/routes';

const Header = styled.header`
  position: relative;
  width: 100%;
  background-color: var(--secondary);
`;

const Nav = styled.div`
  display: flex;
  min-height: 80px;
  align-items: center;

  @media only screen and (max-width: 577px) {
    flex-direction: column;
  }
`;

const Right = styled.div`
  margin-left: auto;

  @media only screen and (max-width: 577px) {
    margin-left: initial;
    padding-top: 5px;
  }

  ul {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;

    @media only screen and (max-width: 577px) {
      flex-direction: column;
    }

    li {
      margin: 0 15px;

      @media only screen and (max-width: 577px) {
        margin: 15px 15px;
      }
    }
  }
`;

const Logo = styled(Link)`
  font-size: 2rem;
  color: var(--text);
  text-decoration: none;

  @media (max-width: 385px) {
    font-size: 10vw;
  }

  span {
    color: var(--cta);
  }
`;

const StyledButton = styled(Link)`
  color: var(--text);
  font-size: 1.5rem;
  padding: 20px;
  text-decoration: none;

  :hover {
    color: var(--success);
  }
`;

const LogoutButton = styled.span`
  color: var(--text);
  font-size: 1.5rem;
  padding: 20px;
  cursor: pointer;

  :hover {
    color: var(--success);
  }
`;

const Navbar = () => {
  const { firebase } = useContext(FirebaseContext);

  function handleLogoutClick() {
    firebase.doSignOut().then(() => navigate('/login'));
  }

  return (
    <Header>
      <Container normal>
        <Nav>
          {typeof window !== 'undefined' && !localStorage.getItem('authUser') && (
            <Logo to={ROUTES.LANDING}>
              root@
              <span>hackersent</span>
              :~#
            </Logo>
          )}

          {typeof window !== 'undefined' && localStorage.getItem('authUser') && (
            <Logo to={ROUTES.APP_LEARN}>
              root@
              <span>hackersent</span>
              :~#
            </Logo>
          )}

          <Right>
            {typeof window !== 'undefined' &&
              !localStorage.getItem('authUser') && (
                <>
                  <StyledButton to="/login">Login</StyledButton>
                  <StyledButton to="/signup">Signup</StyledButton>
                </>
              )}
            {typeof window !== 'undefined' &&
              localStorage.getItem('authUser') && (
                <LogoutButton onClick={handleLogoutClick}>Logout</LogoutButton>
              )}
          </Right>
        </Nav>
      </Container>
    </Header>
  );
};

export default Navbar;
